import React from 'react';
import Catalog from '../components/Catalog';

const CatalogPage = () => {
  return (
    <main className="py-8">
      <Catalog />
    </main>
  );
};

export default CatalogPage; 